<template>
  <div class="content center height">
    <div style="width:100%;">
    <h1 class="content-title p">服务价值</h1>
    <p class="p">service value</p>
    <div class="content-wrap col-xs-12 col-sm-8 col-md-6">
      <div class="content-wrap-all flex-space-around">
        <img class="content-wrap-img"  :style="`top:${top}px;`" src="../assets/untitled-13.png" alt="">
        <div >
        <div class="content-wrap-list">
          <span>01</span>
          <span>—</span>
          <span>人力服务商价值</span>
        </div>
        <div class="content-wrap-title">
          <p>一个助力企业发展的平台，专业的保洁服务培训</p>
          <p>人力服务商赋能，更大的发展空间。</p>
        </div>
        <div class="content-wrap-list">
          <span>02</span>
          <span>—</span>
          <span>酒店价值</span>
        </div>
        <div class="content-wrap-title">
          <p>为酒店提供全套一站式的互联网数字化专业运营平台。</p>
          <p>建立平台服务标准，提高酒店收益，降低酒店成本。</p>
        </div>
        <div class="content-wrap-list">
          <span>03</span>
          <span>—</span>
          <span>社会价值</span>
        </div>
        <div class="content-wrap-title">
          <p>提升酒店保洁服务品质，推动行业保洁服务能力</p>
          <p>提升资源共享，通过能力输出，降低社会整体的服务成本</p>
        </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      height: 0,
      style: '',
      top: ''
    }
  },
  created () {
  },
  mounted () {
    this.height = window.innerHeight -60;
    this.style = `height:${window.innerHeight -300}px;`;
    this.top = (window.innerHeight -560)/2;
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
  @import '../assets/scss/index.scss';
  @media screen and (min-width:0px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 750px;
    }
  }
  @media screen and (min-width:900px) and (max-width:1200px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 900px;
    }
  }
  @media screen and (min-width:600px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 950px;
    }
  }
  @media screen and (min-width: 1200px) {
    .height{
      /*height: calc(100vh - 60px);*/
      /*height: calc(100vh - 60px);*/
    }
  }
  @media screen and (max-width: 420px) {
      // .height{
      //   height: 800px;
      // }
       .content-wrap{
        // @include px2rem(height, 1300);
        position: relative;
        border: 8px solid #ff6d1d;
        margin: 20px auto;
      }
      .content-wrap-img{
        margin-top: 20px;
        @include px2rem(width, 550);
      }
      .content-wrap-all{
        width: 100%;
      }
  }
  @media screen and (max-width: 768px) {
    /*  .height{
        height: 800px;
      }*/
       .content-wrap{
        // @include px2rem(height, 1000);
        position: relative;
        border: 8px solid #ff6d1d;
        margin: 20px auto;
      }
      .content-wrap-img{
        margin-top: 20px;
        @include px2rem(width, 450);
      }
      .content-wrap-all{
        width: 100%;
      }
  }
  @media screen and (min-width: 768px) {
      .content-wrap{
        // @include px2rem(height, 650);
        position: relative;
        border: 8px solid #ff6d1d;
        // margin: 20px auto;
        // : 300px;
        width: 80%;
        margin-left: 10%;
        // @include px2rem(margin-left,500);

      }
      .content-wrap-img{
        // position:absolute;
        @include px2rem(right, -360);
        @include px2rem(width, 550);
      }
      .content-wrap-all{
        width: 100%;
        // position: absolute;
        padding: 20px;
        @include px2rem(left, 30);
      }
  }
  .content{
    width: 100%;
    @include px2rem(padding, 30);
    background: #fff;
    box-sizing: border-box;

    .p{
      width: 100%;
    }
  }
  .content-title{
    // @include px2rem(font-size, 30);
  }

  .content-wrap-list{
    @include px2rem(width, 300);
    @include px2rem(margin-top, 30);

    @include flex(start);
    span{
      color:#ff6d1d;
    }
    span:nth-child(1){
      @include px2rem(font-size, 30);
      font-weight: 600;
    }
    span:nth-child(2){
      @include px2rem(font-size, 22);
      margin: 0 20px;
    }
    span:nth-child(3){
      @include px2rem(font-size, 22);
    }
  }
  .content-wrap-title{
    // margin-left: 95px;
    @include px2rem(margin-left, 115);
    @include px2rem(width, 420);
    @include px2rem(line-height, 50);
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexContent.vue